import { forwardRef } from 'react';

import DecimalNumberInline from 'components/Inputs/inline/TextInput/presets/DecimalNumber';
import { withCellWrapper } from './helpers';

const _DecimalNumberCell = forwardRef(
  (
    {
      field,
      entityId,
      entityAccess,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      onAutoFocus,
      ...others
    },
    ref
  ) => {
    return (
      <DecimalNumberInline
        ref={ref}
        {...others}
        field={field}
        entityId={entityId}
        value={value}
        onSubmit={onSubmit}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        decimalOptions={field.decimalOptions}
      />
    );
  }
);

export const DecimalNumberCell = withCellWrapper(_DecimalNumberCell);
